module.exports = __webpack_public_path__ + "img/center.507e8074.svg";